import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-dynamic-map-component', (editor, opts) => {
  const config = {
    blocks: [
      'dynamicMapComponent',
    ],
    name: 'dynamicMapComponent',
    stylePrefix: 'gjs-',
    defText: 'Sample',
    category: 'Dinamismo',
    labelComponent: 'Mapa Dinamico',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
